import {
    PRESUPUESTADOR_UPDATE_TAKING_CAR,
} from '../constants';


export function updateTakingCar(takingCar = {}) {
    return (dispatch) => {
        dispatch({
            type: PRESUPUESTADOR_UPDATE_TAKING_CAR,
            data: { takingCar }
        })
    }
}